function prettyFloat( num: number ): number {

  let float = num.toFixed( 2 );
  return +float.split('.')[ 1 ] > 0 ? +float : num

}

export default prettyFloat;